import {Button, styled} from '@mui/material';

const StyledButton = styled(Button)`
	padding: 0;
	margin-top: auto;
	min-width: 0;
	font-weight: 400;
	text-decoration: underline;

	&:hover {
		text-decoration: underline;
	}
`;
export {StyledButton};
